export type ChatRole = "system" | "user" | "assistant";

export interface ChatMessage {
  role: ChatRole;
  content: string;
}

export interface ChatResponse {
  message: ChatMessage;
  raw?: unknown;
}

/** POST /api/chat (proxied by Cloudflare Pages Function to the CoS Hermes API). */
export async function sendChat(messages: ChatMessage[]): Promise<ChatResponse> {
  const resp = await fetch("/api/chat", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ messages }),
  });

  if (!resp.ok) {
    let detail = "";
    try {
      detail = (await resp.text()).slice(0, 500);
    } catch {
      /* ignore */
    }
    throw new Error(`Cockpit API ${resp.status}: ${detail || resp.statusText}`);
  }

  const data = (await resp.json()) as { message?: ChatMessage; raw?: unknown };
  if (!data.message?.content) {
    throw new Error("Cockpit API returned no message content");
  }
  return { message: data.message, raw: data.raw };
}
